import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


export default function initCarouselThematiques(): void {
    const $carouselThematiquesContainer = document.querySelectorAll<HTMLElement>('.block-carousel-thematiques');
    $carouselThematiquesContainer.forEach($container => {
        new CarouselThematiques($container);
    });
}

class CarouselThematiques {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    $navigation_prev: HTMLElement | null | undefined;
    $navigation_next: HTMLElement | null | undefined;
    swiper: Swiper | null = null;
    mdBreakpoint: number | null = null;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = $el?.querySelector('.thematiques');
        this.$navigation_prev = $el?.querySelector('.swiper-navigation .button-prev');
        this.$navigation_next = $el?.querySelector('.swiper-navigation .button-next');
        this.mdBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'));
        this.init();
    }

    init(): void {
        if (this.$slider) {
            // Initialisation initiale
            this.handleResize();
            
            // Écouter les changements de taille d'écran
            window.addEventListener('resize', () => {
                this.handleResize();
            });
        }
    }

    handleResize(): void {
        const isDesktop = window.innerWidth >= (this.mdBreakpoint || 0);

        if (isDesktop && !this.swiper) {
            // Initialiser Swiper en desktop
            this.initSwiper();
        } else if (!isDesktop && this.swiper) {
            // Détruire Swiper en mobile
            this.destroySwiper();
        }
    }

    initSwiper(): void {
        this.swiper = new Swiper(this.$slider!, {
            modules: [Navigation],
            slidesPerView: 'auto',
            loop: false,
            allowTouchMove: true,
            spaceBetween: 20,
            grabCursor: true,
            navigation: {
                nextEl: this.$navigation_next,
                prevEl: this.$navigation_prev,
            },
        });
    }

    destroySwiper(): void {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}
